module.exports = __webpack_public_path__ + "media/images/logos/investissement-avenir-07442241c2de4a2a57a9875d2e6e1e88.jpg";